<template>
  <div class="auth">
    <router-link class="add-link" to="/login">Sign in</router-link>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
